import { Playground } from '../../../components/playground/Playground';
import { PlaygroundClasses } from '../../../components/playground/PlaygroundClasses';
import { Headline } from '../../../components/Headline';

export const TextAlignment = () => (
    <div>
        <Headline anchor='alignment'>Alignment</Headline>
        <Playground example={alignmentExample} classes={alignmentClasses} />
    </div>
);

const alignmentExample = (
    <div className='display-grid grid-cols-1 gap-5'>
        <div className='text-left bg-lightest padding-10 rounded'>text-left</div>
        <div className='text-center bg-lightest padding-10 rounded'>text-center</div>
        <div className='text-right bg-lightest padding-10 rounded'>text-right</div>
    </div>
);

const alignmentClasses = <PlaygroundClasses prefix='text-' classes={['left', 'center', 'right']} />;
